/**
 * @author Ariel
 * @description 消息通知记录页面
 * @Date 2021/06/24
 */
import React from "react";
import {connect} from "dva";
import {templateConfig,reduxTemplateConfig} from "./config";
import {component_tool,framework_tool} from '../../../tool';
let {WizContainer, WizReduxTemplate,modelUtils} = framework_tool;

class NoticeRecord extends WizContainer {
  componentName = 'noticeRecord';

  constructor(props) {
    super(props);
    this.state={
      sceneByTypeList: []
    }
  }

  _getSceneByType = (bizType) => {
    this.doAction({
      path: 'messageNoticeRecord/getSceneByType', //获取岗位分类列表
      payload: {
        key: 'getSceneByType',
        apiParams: {
          bizType: bizType
        }
      },
      requireLoading: true,
    })
  }

  propsAndStateOnChange = {
    sceneByTypeList: this.getSceneByTypeListOnChange.bind(this)
  }

  getSceneByTypeListOnChange(nextProps, nextState) {
    let _list = [];
    if (nextProps['sceneByTypeList'] && nextProps['sceneByTypeList']['success'] === true) {
      let list = nextProps["sceneByTypeList"]['data']
      list && list.forEach(val => {
        _list.push({ code: val, codeName: val })
      });
      nextState['sceneByTypeList'] = _list;
      return true;
    } else {
      wizNotice.error(nextProps["sceneByTypeList"]['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({self:this}),
      apiDataFormat: {},
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  const {messageNoticeRecord} = state
  const sceneByTypeList = modelUtils.getModelEntity(messageNoticeRecord,'getSceneByType')
  const load = modelUtils.getLoadingState(state,'messageNoticeRecord')
  return {
    sceneByTypeList,
    ...load
  }
};

export default connect(mapStateToProps)(NoticeRecord);
